import React, { Component } from 'react';
import './Footer.css';
import axios from 'axios';
import fblogo from '../static/icons/facebookblack.svg';
import instalogo from '../static/icons/nyinstagram.svg';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import Image from 'react-bootstrap/lib/Image';
let back = 'https://backend.themusiccompany.dk';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      footer: null,
    };
  }

  componentDidMount() {
    axios.get(back + '/footer/?format=json').then((res) => {
      const ft = <p className="footerText">The Music Company</p>;

      this.setState({ footer: ft });
    });
  }

  render() {
    return (
      <Row className="footer">
        <Col className="nopadding" xs={12} sm={12} md={12} lg={12}>
          <a
            className="fblogo"
            href="https://www.facebook.com/themusiccompanydk/"
            target="_blank"
          >
            <Image responsive alt="fblogo" src={fblogo} />
          </a>
          <a
            className="instalogo"
            href="https://www.instagram.com/themusiccompanydk/"
            target="_blank"
          >
            <Image responsive alt="fblogo" src={instalogo} />
          </a>
          {this.state.footer}
        </Col>
      </Row>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/objs/Footer.js